import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import '../reports/payment-video.css'
import './my-dashboard.css'
import SharedData from '../common/SharedData'
import ActiveProductsCard from './active-products/ActiveProducts'
import BestSellerProductsCard from './best-seller-products/BestSellerProductsCard'
import DailySales from './daily-sales/DailySales'
import MonthlyServiceCard from './monthly-service/MonthlyServiceCard'
// import NextPaymentCard from './next-payment/NextPaymentCard' // Removed unused import
import PendingOrdersCard from './pending/PendingOrdersCard'
import {TutorialVideoLink} from '../../tenant/TutorialVideoLink'
import {tenantFeatureEnabled} from '../../tenant/tenantState'
// import SalesChart from './sales/SalesChart' // Removed SalesChart import
import StockQtyCard from './stock-quantity/StockQtyCard'
import TransactionSummaryCard from './transaction-summary/TransactionSummaryCard'
import InTransitCard from './in-transit/InTransitCard' // Added InTransitCard import
import SupportCard from './support-card/SupportCard' // Import the new SupportCard
import WinRateCard from './win-rate/WinRateCard'

const MyDashboard = () => {
  const {currentUser, language} = SharedData()
  const { formatMessage } = useIntl()
  const [showVideoHighlight, setShowVideoHighlight] = useState(false)

  useEffect(() => {
    const hasSeenVideo = document.cookie
      .split(';')
      .some(item => item.trim().startsWith('dashboard_video='));

    setShowVideoHighlight(!hasSeenVideo);
  }, []);
  return (
    <div className='hsb-dash'>
      {/* begin::Header — title + subtitle | Tutorial Video + Add Daily Deals */}
      <div className='hsb-header'>
        <div>
          <h1 className='hsb-header__title'>{formatMessage({ id: 'DASHBOARD.INSIGHTS_TITLE' })}</h1>
          <p className='hsb-header__subtitle'>{formatMessage({ id: 'DASHBOARD.INSIGHTS_SUBTITLE' })}</p>
        </div>
        <div className='hsb-header__actions'>
          <TutorialVideoLink
            section="dashboard"
            fallback="https://www.youtube.com/watch?v=A1SuthRKWPY"
            target="_blank"
            rel="noopener noreferrer"
            className={`hsb-video-link ${showVideoHighlight ? 'video-highlight' : ''}`}
            onClick={() => {
              document.cookie = "dashboard_video=seen";
              setShowVideoHighlight(false);
            }}
          >
            <span className='material-symbols-outlined'>play_circle</span>
            <span>{formatMessage({ id: 'video_link' })}</span>
          </TutorialVideoLink>
          {tenantFeatureEnabled('daily_deals') && (
            <a href='/daily-deal/list' className='hsb-btn-tertiary'>
              <span className='material-symbols-outlined'>add_circle</span>
              <span>{formatMessage({ id: 'DASHBOARD.ADD_DAILY_DEAL' })}</span>
            </a>
          )}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Top Row — 5 KPI cards (spans mirror the redesign: 3-3-2-2-2) */}
      <div className='row g-6 mb-6 align-items-stretch'>
        <div className='col-12 col-sm-6 col-lg-3'>
          <TransactionSummaryCard
            currentUser={currentUser}
            language={language}
            className='h-100'
          />
        </div>
        <div className='col-12 col-sm-6 col-lg-3'>
           <InTransitCard
            currentUser={currentUser}
            language={language}
            className='h-100'
          />
        </div>
        <div className='col-12 col-sm-6 col-lg-2'>
          <StockQtyCard
            currentUser={currentUser}
            language={language}
            className='h-100'
          />
        </div>
         <div className='col-12 col-sm-6 col-lg-2'>
          <DailySales
            currentUser={currentUser}
            language={language}
            className='h-100'
          />
        </div>
        <div className='col-12 col-sm-6 col-lg-2'>
          <ActiveProductsCard
            currentUser={currentUser}
            language={language}
            className='h-100'
          />
        </div>
      </div>
      {/* end::Top Row */}

      {/* begin::Performance Row — Win Rate (4) + Monthly Service (8) */}
      {/* Win Rate self-hides for legacy suppliers with no active offers;
          Monthly Service then fills the row — acceptable for that edge case. */}
      <div className='row g-6 mb-6 align-items-stretch'>
        <div className='col-12 col-lg-4'>
          <WinRateCard
            currentUser={currentUser}
            language={language}
            className='h-100'
          />
        </div>
        <div className='col-12 col-lg-8'>
          <MonthlyServiceCard
            currentUser={currentUser}
            language={language}
            className='h-100'
          />
        </div>
      </div>
      {/* end::Performance Row */}

      {/* begin::Tables Row — Best Sellers (5) + Pending Orders (7) */}
      <div className='row g-6 mb-6'>
        <div className='col-12 col-lg-5'>
          <BestSellerProductsCard
            currentUser={currentUser}
            language={language}
            className=''
          />
        </div>
        <div className='col-12 col-lg-7'>
          <PendingOrdersCard
            currentUser={currentUser}
            language={language}
            className=''
          />
        </div>
      </div>
      {/* end::Tables Row */}
    </div>
  )
}

export default MyDashboard
